import { useEffect, useState, useCallback } from "react";
import { useFetcherResult } from "./useActionResult";
import { useLocalePath } from "./useLocale";
import { AuthActions } from "~/lib/action/actions";
import { z } from "zod";

export const useRequestActivationEmail = () => {
  const [requestSent, setRequestSent] = useState(false);
  const localePath = useLocalePath();

  const {
    fetcher: { submit, data },
    isLoading,
  } = useFetcherResult();

  const requestActivationEmail = useCallback(
    (email: string) => {
      const emailSchema = z.string().email();
      if (!emailSchema.safeParse(email).success) return;
      submit(
        { email, _action: AuthActions.REQUEST_ACTIVATION },
        { method: "post", action: localePath(`/customer/login`) }
      );
    },
    [submit, localePath]
  );

  useEffect(() => {
    if (
      isLoading ||
      data === undefined ||
      data.errors?.length
    )
      setRequestSent(false);
    if (!isLoading && data !== undefined && !data.errors?.length)
      setRequestSent(true);
  }, [isLoading, data]);

  return {
    requestingEmail: isLoading,
    requestSent,
    requestError: data?.errors?.length ? data?.errors : [],
    requestActivationEmail,
  };
};
